import { render, staticRenderFns } from "./InfoCredits.vue?vue&type=template&id=6f9aa5ff&"
import script from "./InfoCredits.vue?vue&type=script&lang=js&"
export * from "./InfoCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports